<template>
  <div>
    <BaseTitle :title="$t('content.class_level_list')" />
    <v-card>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.class_level_list') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div>
              <v-btn
                outlined
                color="primary"
                class="btn-primary-custom mb-2 mb-md-0 mr-md-2"
                v-if="position === false && permissionButton('ROLE_CLASS_LEVEL_MANAGEMENT_VIEW')"
                @click="editPosition()"
                >{{ $t('content.edit_position') }}</v-btn
              >
              <v-btn
                color="primary"
                class="btn-primary-custom mb-2 mb-md-0 mr-md-2"
                v-if="position === true && permissionButton('ROLE_CLASS_LEVEL_MANAGEMENT_VIEW')"
                @click="editPosition()"
                >{{ $t('save') }}</v-btn
              >
            </div>
            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="search" :label="$t('search')" @change="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <!-- draggable active -->
        <draggable
          v-if="position === true"
          :list="listData"
          :animation="200"
          ghost-class="moving-card"
          group="listData"
          filter=".action-button"
          class="w-full max-w-md"
          tag="ul"
        >
          <div class="pa-4 ml-4 mr-4 mb-4" v-for="(item, index) in listData" :key="index">
            <div class="bg-col pa-3">
              <v-row>
                <v-col md="1" class="ml-6">
                  <v-avatar color="primary" size="48"
                    ><strong class="white--text">{{ item.position }}</strong></v-avatar
                  >
                </v-col>
                <v-col md="6" class="ml-6 mt-3">
                  <strong class="d-inline pa-2">{{ $t('content.class_level') }}: {{ item.name }}</strong>
                </v-col>
              </v-row>
            </div>
          </div>
        </draggable>
        <!-- draggable Inactive -->
        <div v-if="position === false" class="w-full max-w-md">
          <div class="pa-4 ml-4 mr-4 mb-4" v-for="(item, index) in listData" :key="index">
            <div class="bg-col pa-3">
              <v-row>
                <v-col md="1" class="ml-6">
                  <v-avatar color="primary" size="48"
                    ><strong class="white--text">{{ item.position }}</strong></v-avatar
                  >
                </v-col>
                <v-col md="6" class="ml-6 mt-3">
                  <strong class="d-inline pa-2">{{ $t('content.class_level') }}: {{ item.name }}</strong>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <br />
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import draggable from 'vuedraggable';

export default {
  name: 'ClassLevelListPosition',
  components: {
    BaseTitle,
    draggable
  },
  computed: {
    ...mapGetters({
      items: 'ClassLevel/items',
      user: 'Auth/user',
      permission: 'Auth/permission'
    }),
    tableHeader() {
      return [
        { text: this.$t('table.grade'), value: 'name' },
        { text: this.$t('table.access_parent'), value: 'parentAccess' },
        { text: this.$t('table.action'), value: 'actions', sortable: false, width: 180 }
      ];
    }
  },
  data: () => ({
    dialogDelete: false,
    currentItem: null,
    listData: [],
    search: '',
    loadingLoad: false,
    position: false,
    table: {
      loading: false,
      options: {}
    }
  }),
  watch: {
    'table.options': function() {
      this.getData();
    }
  },
  methods: {
    permissionButton(push) {
      return this.permission.some(p => p === push) ?? false;
    },
    onPopUp() {
      this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_class_level_index') });
    },
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('ClassLevel/fetchListPosition', {
          search: this.search
        })
        .then(data => {
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            element.position = index + 1;
          }
          this.listData = data;
        })
        .finally(() => (this.loadingLoad = false));
    },
    editPosition() {
      if (this.position === false) {
        this.position = true;
      } else {
        let data = this.listData;
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          element.position = index + 1;
        }
        this.$store.dispatch(`ClassLevel/updatePosition`, { data }).finally(() => {
          this.getData();
          this.position = false;
        });
      }
    }
  },
  created() {
    this.getData();
    this.$store.commit('table/RESET_PAGEABLE');
  }
};
</script>

<style lang="scss" scoped>
.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}

.pointer {
  cursor: pointer;
}
.bg-col {
  background-color: #b2ebd0;
  border-radius: 8px;
}

.card-modules {
  background-color: #ffffff;
  border-radius: 8px;
}
.divider {
  border: 1px solid #dedede;
  width: 1px;
  height: 28px;
}
.moving-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
</style>
